import { deeplyTransformEmptyStringToUndefined } from "utilities";
import { Route as AppRoute } from "utilities/app-routes";
import { formatTouchpointClassesForApi } from "components/modals/creative-modal/creative-modal-utils";

import { AddEmailFormData } from "components/modals/creative-modal/creative-modal-types";

import type {
  TouchpointCreateRequest,
  TouchpointCreateRequestContentType,
  TouchpointCreateRequestPopulationType,
  TouchpointVersionCreateRequest,
} from "generated/schemas";

type CreateTouchpointFn = (args: {
  data: TouchpointCreateRequest;
  versionData: TouchpointVersionCreateRequest;
}) => Promise<{ touchpoint: { id: string }; version?: { id: string } }>;

type SubmitCreateBlankEmailParams = {
  data: AddEmailFormData;
  clientId: string;
  campaignId: string;
  createTouchpoint: CreateTouchpointFn;
};

export const submitCreateBlankEmail = async ({
  data,
  clientId,
  campaignId,
  createTouchpoint,
}: SubmitCreateBlankEmailParams): Promise<string> => {
  const emailAttributes = deeplyTransformEmptyStringToUndefined({
    name: data.name,
    contentType: data.contentType,
  });

  const payload: TouchpointCreateRequest = {
    name: emailAttributes.name || "",
    type: "EMAIL",
    contentType: emailAttributes.contentType as TouchpointCreateRequestContentType,
    folderId: data.folderId,
    copyCode: data.copyCode,
    insightsActivator: data.insightsActivator,
    populationType: data.populationType as TouchpointCreateRequestPopulationType,
    classes: formatTouchpointClassesForApi(data.classes),
  };
  const versionPayload: TouchpointVersionCreateRequest = {
    description: "Initial draft",
    applyClientTheme: data.applyClientTheme ?? true,
    fiscalYear: data.fiscalYear,
  };
  const { touchpoint, version } = await createTouchpoint({
    data: payload,
    versionData: versionPayload,
  });
  if (!version) throw new Error("Touchpoint version was not created");
  return `/clients/${clientId}/campaigns/${campaignId}/creative/${touchpoint.id}/${AppRoute.versions}/${version.id}/${AppRoute.emailBuilder}`;
};
